import { addProp } from "@pnp/odata";
import { _Group } from "../groups/types.js";
import { Plans } from "./types.js";
addProp(_Group, "plans", Plans, "planner/plans");
//# sourceMappingURL=groups.js.map